const getters = {
    getDoctorList: state => state.list,
    // 筛选出手术医生13// 实际手术医生13
    getList13(state) {
        state.list.forEach(ele => {
            if (ele.menuType == 13) {
                state.list13.push(ele)
            }
        });
        return state.list13
    },

}
export default getters